import storageService from "@/services/middleware/storageService";
import { PLAN_MODE } from "@/utilities/constants";

export const flattenedDimensionsList = [
  {
    type: "separator",
    key: "trafficSeparator",
    text: "Traffic",
    childType: "traffic",
  },
  { type: "traffic", key: "offer", text: "Offer" },
  { type: "traffic", key: "campaign", text: "Campaign" },
  { type: "traffic", key: "trafficSource", text: "Traffic source" },
  { type: "traffic", key: "subPublisher", text: "Sub-publisher" },

  { type: "separator", key: "timeSeparator", text: "Time", childType: "time" },
  { type: "time", key: "day", text: "Day" },
  { type: "time", key: "hour", text: "Hour" },
  { type: "time", key: "month", text: "Month" },
  { type: "time", key: "year", text: "Year" },

  {
    type: "separator",
    key: "deviceSeparator",
    text: "Device",
    childType: "os",
  },
  { type: "os", key: "device", text: "Device Type" },
  { type: "os", key: "os", text: "Device OS" },
  { type: "os", key: "browser", text: "Browser" },

  {
    type: "separator",
    key: "targetSeparator",
    text: "Target",
    childType: "target",
  },
  { type: "target", key: "country", text: "Country" },
  { type: "target", key: "isp", text: "ISP" },

  {
    type: "separator",
    key: "websiteSeparator",
    text: "Website Details",
    childType: "website",
  },
  { type: "website", key: "opt_domain", text: "Domain" },
  { type: "website", key: "referer", text: "Referrer" },

  {
    type: "separator",
    key: "googleSeparator",
    text: "Google Traffic",
    childType: "google",
  },
  { type: "google", key: "googleCampaignType", text: "Campaign Type (Google)" },
  { type: "google", key: "googleCampaignId", text: "Campaign ID (Google)" },
  { type: "google", key: "googleCampaignName", text: "Campaign Name (Google)" },
  { type: "google", key: "googlePlacement", text: "Placement (Google)" },
  { type: "google", key: "googleKeyword", text: "Keyword (Google)" },
  { type: "google", key: "googleAccountId", text: "Account ID (Google)" },
  { type: "google", key: "googleAccountName", text: "Account Name (Google)" },

  {
    type: "separator",
    key: "segmentationSeparator",
    text: "Segmentation",
    childType: "segmentation",
  },
  { type: "segmentation", key: "trafficType", text: "Traffic Channels" },
  { type: "segmentation", key: "utm_source", text: "UTM Source" },
  { type: "segmentation", key: "utm_campaign", text: "UTM Campaign" },
  { type: "segmentation", key: "utm_medium", text: "UTM Medium" },
  { type: "segmentation", key: "utm_content", text: "UTM Content" },
  { type: "segmentation", key: "utm_term", text: "UTM Term" },

  {
    type: "separator",
    key: "customSeparator",
    text: "Custom",
    childType: "custom",
  },
  { type: "custom", key: "var1", text: "Var1" },
  { type: "custom", key: "var2", text: "Var2" },
  { type: "custom", key: "var3", text: "Var3" },
  { type: "custom", key: "var4", text: "Var4" },
  { type: "custom", key: "var5", text: "Var5" },
  { type: "custom", key: "var6", text: "Var6" },
  { type: "custom", key: "var7", text: "Var7" },
  { type: "custom", key: "var8", text: "Var8" },
  { type: "custom", key: "var9", text: "Var9" },
  { type: "custom", key: "var10", text: "Var10" },
  { type: "custom", key: "var11", text: "Var11" },
  { type: "custom", key: "var12", text: "Var12" },
  { type: "custom", key: "var13", text: "Var13" },
  { type: "custom", key: "var14", text: "Var14" },
  { type: "custom", key: "var15", text: "Var15" },
  { type: "custom", key: "var16", text: "Var16" },
  { type: "custom", key: "var17", text: "Var17" },
  { type: "custom", key: "var18", text: "Var18" },
  { type: "custom", key: "var19", text: "Var19" },
  { type: "custom", key: "var20", text: "Var20" },

  {
    type: "separator",
    key: "securitySeparator",
    text: "Security",
    childType: "security",
  },
  { type: "security", key: "hitSecurityLevel", text: "Visit Traffic Veracity" },
  { type: "security", key: "hitStatus", text: "Visit Status" },
];

export const dimensionsList = [
  {
    name: "Traffic",
    key: "trafficSeparator",
    options: ["offer", "campaign", "trafficSource", "subPublisher"].map((f) =>
      flattenedDimensionsList.find((ff) => ff.key === f)
    ),
  },
  {
    name: "Time",
    key: "timeSeparator",
    options: ["day", "hour", "month", "year"].map((f) =>
      flattenedDimensionsList.find((ff) => ff.key === f)
    ),
  },
  {
    name: "Device",
    key: "deviceSeparator",
    options: ["device", "os", "browser"].map((f) =>
      flattenedDimensionsList.find((ff) => ff.key === f)
    ),
  },
  {
    name: "Target",
    key: "targetSeparator",
    options: ["country", "isp"].map((f) =>
      flattenedDimensionsList.find((ff) => ff.key === f)
    ),
  },
  {
    name: "Website Details",
    key: "websiteSeparator",
    options: ["opt_domain", "referer"].map((f) =>
      flattenedDimensionsList.find((ff) => ff.key === f)
    ),
  },
  {
    name: "Google Traffic",
    key: "googleSeparator",
    options: [
      "googleCampaignType",
      "googleCampaignId",
      "googleCampaignName",
      "googleAccountId",
      "googleAccountName",
      "googlePlacement",
      "googleKeyword",
    ].map((f) => flattenedDimensionsList.find((ff) => ff.key === f)),
  },
  {
    name: "Segmentation",
    key: "segmentationSeparator",
    options: [
      "trafficType",
      "utm_source",
      "utm_campaign",
      "utm_medium",
      "utm_content",
      "utm_term",
    ].map((f) => flattenedDimensionsList.find((ff) => ff.key === f)),
  },
  {
    name: "Custom",
    key: "customSeparator",
    options: [
      "var1",
      "var2",
      "var3",
      "var4",
      "var5",
      "var6",
      "var7",
      "var8",
      "var9",
      "var10",
      "var11",
      "var12",
      "var13",
      "var14",
      "var15",
      "var16",
      "var17",
      "var18",
      "var19",
      "var20",
    ].map((f) => flattenedDimensionsList.find((ff) => ff.key === f)),
  },
  {
    name: "Security",
    key: "securitySeparator",
    options: ["hitSecurityLevel", "hitStatus"].map((f) =>
      flattenedDimensionsList.find((ff) => ff.key === f)
    ),
  },
];

export const defaultDimensions = () => {
  const isMvas = storageService.getItem("vas") === true;
  const isFree = storageService.getItem("user-type") === PLAN_MODE.FREE;
  return isFree ? ["day"] : isMvas ? ["campaign"] : ["trafficType"];
};

export const dimensionsKeys = flattenedDimensionsList
  .filter((d) => d.type !== "separator")
  .map((d) => d.key);

export const dimensionsKeyObject = (() => {
  const obj: {
    [k: string]: {
      type: string;
      key: string;
      text: string;
    };
  } = {};

  flattenedDimensionsList.forEach((dimension) => {
    obj[dimension.key] = dimension;
  });

  return obj;
})();

export const calculateDefaultDimensions = () => {
  const dimensions = storageService.getItem("dimensions");

  let includesDimensions;
  dimensions?.forEach((element: string) => {
    includesDimensions = flattenedDimensionsList
      .map((x) => x.key)
      .includes(element);
  });

  if (includesDimensions) {
    return {
      keys: dimensions,
      list: flattenedDimensionsList.filter(
        (e) => dimensions.indexOf(e.key) > -1
      ),
    };
  }

  return {
    keys: defaultDimensions(),
    list: flattenedDimensionsList.filter(
      (e) => defaultDimensions().indexOf(e.key) > -1
    ),
  };
};
